import apiClient from "./config";
import { SHOP_TRACKING_ENDPOINTS } from "./endpoints";

const shopTrackingServices = {
  // Get Search Results
  shopVisits: (data) => {
    return apiClient.post(SHOP_TRACKING_ENDPOINTS.SHOP_VISITS, data);
  },
  productView: (data) => {
    return apiClient.post(SHOP_TRACKING_ENDPOINTS.PRODUCT_VIEW, data);
  },
  addInCart: (data) => {
    return apiClient.post(SHOP_TRACKING_ENDPOINTS.PRODUCT_ADDED_IN_CART, data);
  },
  
 

};

export default shopTrackingServices;